export const termsAndConditionsStrings = {
    en:{
        termsAndConditionsTitle:"Terms & Conditions",
    },
    pl: {
        termsAndConditionsTitle:"Wraunki użytkowania",
    },
};

export default termsAndConditionsStrings;